import { PageSectionsContentSectionContentBlocksFullWidthImage } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { borderRadius, color } from '../styles/tokens.stylex';
export interface FullWidthImageProps {
  data: PageSectionsContentSectionContentBlocksFullWidthImage;
}
export function FullWidthImage({
  data,
  ...props
}: FullWidthImageProps) {
  return data ? <div className="xrhgmaw x1dltgaz xt9rjjq x1skrob4 x14eurpq xb3r6kr x1n2onr6 x1basc5x x1q1flcd x1razraf x1qcoqpi x1by5hjz x1sfl7fc x1o5z2k8" data-tina-field={tinaField(data, 'image')} {...props}>
      {data.image && <Image className="xl1xv1r xwbza2d" src={data.image} alt={data.alt} fill sizes="100vw, (min-width: 1400px) 1400px" />}
    </div> : null;
}